import { Box, TextField, InputAdornment, TableContainer, Table, TableBody, TableRow, TableCell, Checkbox, IconButton, Popover, MenuItem, Typography, Avatar, FormControl, InputLabel, Select, Grid, TableHead, Divider, LinearProgress, Hidden } from "@mui/material";
import SearchIcon from '@mui/icons-material/Search';
import MoreHorizIcon from '@mui/icons-material/MoreHoriz';
import { useTranslation } from "react-i18next";
import { numberFormat } from "../../utils/nunberFormat";
import { DEFAULT_ROWS_PER_PAGE } from "../../config-global";
import Pagination from '@mui/material/Pagination';
import { TEXT_TITLE_COLOR } from "../../constants/colors";
import ProductTabPanel from "./components/tabPanel";
import ACTIVE_PRODUCT_STATISTIC from '../../assets/images/active_product_static.svg';
import InfoIcon from '@mui/icons-material/Info';
import { IMAGE_CUSTOMER } from "../../lib/endpoints/customer";
import { OrderModel } from "../../models/order";
import { calculateOrderProductUnitByCarts } from "../../utils/calculateOrderProductUnitByCarts";
import OrderDetail from "./Detail";
import useReturnOrderController from "./controller";
import { findOrderCreateTime } from "../../utils/findOrderCreareTime";
import LoadingAnimatedIcon from "../../components/loading/loadingAnimated";
import { findPhoneFromOrder } from "../../utils/findPhoneFromOrder";

const ReturnOrderView = () => {
    const { t } = useTranslation("global");

    const controller = useReturnOrderController();

    // const tableHeaders: string[] = [t("No."), t("Image"), t("Product name"), t("Barcode"), t("Branch"), ""];
    const tableHeaders: string[] = [t("order_page.No"), t("order_page.Customer name"), t("order_page.Order ID"), t("order_page.Order number"), t("order_page.Item unit"), t("order_page.Shipment method"), t("order_page.Payment method"), t("order_page.Phone"), t("order_page.Price"), ""];
    const simplifiedHeaders: string[] = [t("order_page.No"), t("order_page.Order ID"), t("order_page.Order time"), ""];
    return <Box>
        {
            !controller.loading
                ?
                !controller.selectedData
                    ?
                    <Box>
                        <Box mb={5} >
                            <Box sx={{ display: 'flex', flexWrap: 'wrap', alignItems: 'center', gap: 2, width: '100%' }}>
                                <Typography variant="h5" fontWeight="bold" color={TEXT_TITLE_COLOR}>{t("drawer_component.Return Order")}</Typography>
                                <TextField onKeyDown={(e: any) => {
                                    if (e.key === "Enter") {
                                        controller.handleGetDataByOrderId();
                                    }
                                }} inputRef={controller.searchRef} fullWidth sx={{ maxWidth: 250 }} placeholder={t("order_page.Search by Order ID") || ""} InputProps={{
                                    startAdornment: (
                                        <InputAdornment position="start" onClick={controller.handleGetDataByOrderId}>
                                            <SearchIcon />
                                        </InputAdornment>
                                    )
                                }} size="small" />
                            </Box>

                        </Box>
                        <Box mb={2}>
                            <Grid container spacing={2}>
                                <Grid item xs={12} sm={6} md={4}>
                                    <Box sx={{ backgroundColor: '#C4EAFF', borderRadius: '16px', p: 4, display: 'flex', justifyContent: 'space-between' }}>
                                        <Box>
                                            <Typography color="#005249" sx={{ mb: 1 }}>{t("order_page.Orders")}</Typography>
                                            <Typography color="#005249" fontWeight="bold" fontSize={32}>{numberFormat(controller.rows?.length)}</Typography>
                                        </Box>
                                        <Box>
                                            <img src={ACTIVE_PRODUCT_STATISTIC} alt="" style={{ width: 100, height: 100 }} />
                                        </Box>
                                    </Box>
                                </Grid>

                            </Grid>
                        </Box>

                        <Box mb={2}>
                            <ProductTabPanel value={controller.currentOrderStatus} onChange={controller.handleCurrentOrderStatusChange} />
                        </Box>

                        {
                            !controller.loadingGetData
                                ?
                                <Box sx={{ mt: 2 }}>
                                    <TableContainer>
                                        <Table>
                                            <TableHead sx={{ background: '#F4F6F8' }}>
                                                <Hidden smDown>
                                                    <TableRow>
                                                        {tableHeaders?.map((item, index) => (
                                                            <TableCell key={index} sx={{ borderBottom: 'none' }}>{item}</TableCell>
                                                        ))}
                                                    </TableRow>
                                                </Hidden>
                                                <Hidden smUp>
                                                    <TableRow>
                                                        {simplifiedHeaders.map((item, index) => (
                                                            <TableCell key={index} sx={{ borderBottom: 'none' }}>{item}</TableCell>
                                                        ))}
                                                    </TableRow>
                                                </Hidden>
                                            </TableHead>
                                            <TableBody>
                                                {
                                                    controller.rows?.map((row: OrderModel, index: number) => {
                                                        const customerImage: string = IMAGE_CUSTOMER + row?.customer?.profile?.image?.url;
                                                        return (
                                                            <>
                                                                <Hidden smDown>
                                                                    <TableRow hover key={row?.id} tabIndex={-1}>
                                                                        <TableCell align="left" sx={{ borderBottom: 'none' }}>{numberFormat((index + 1) + (DEFAULT_ROWS_PER_PAGE * (controller.currentPage - 1)))}</TableCell>
                                                                        <TableCell align="left" sx={{ borderBottom: 'none' }}>
                                                                            <Box sx={{ display: 'flex', gap: 1, alignItems: 'center' }}>
                                                                                <Avatar
                                                                                    src={customerImage}
                                                                                    alt='Customer'
                                                                                    sx={{ cursor: 'pointer', objectFit: 'contain', borderRadius: 12, width: 50, height: 50 }}
                                                                                    onClick={() => window.open(customerImage)}
                                                                                />
                                                                                <Typography>{row?.customer?.profile?.fullName}</Typography>
                                                                            </Box>

                                                                        </TableCell>
                                                                        <TableCell align="left" sx={{ borderBottom: 'none' }}>{row?.orderNo}</TableCell>
                                                                        <TableCell align="left" sx={{ borderBottom: 'none' }}>{row?.orderNumber}</TableCell>
                                                                        <TableCell align="left" sx={{ borderBottom: 'none' }}>{calculateOrderProductUnitByCarts(row?.carts)}</TableCell>
                                                                        <TableCell align="left" sx={{ borderBottom: 'none' }}>{row?.orderMethod}</TableCell>
                                                                        <TableCell align="left" sx={{ borderBottom: 'none' }}>{row?.paymentMethod}</TableCell>
                                                                        <TableCell align="left" sx={{ borderBottom: 'none' }}>{findPhoneFromOrder(row)}</TableCell>
                                                                        <TableCell align="left" sx={{ borderBottom: 'none' }}>{numberFormat(row?.totoalWithDeliveryFee)} {t("Kip")}</TableCell>
                                                                        <TableCell align="right" sx={{ borderBottom: 'none' }}>
                                                                            <IconButton size="large" color="inherit" onClick={(e: any) => controller.handleOpenMenu(e, row?.id)}>
                                                                                <MoreHorizIcon />
                                                                            </IconButton>
                                                                        </TableCell>
                                                                    </TableRow>
                                                                </Hidden>
                                                                <Hidden smUp>
                                                                    <TableRow hover key={row?.id} tabIndex={-1}>
                                                                        <TableCell align="left" sx={{ borderBottom: 'none' }}>{numberFormat((index + 1) + (DEFAULT_ROWS_PER_PAGE * (controller.currentPage - 1)))}</TableCell>
                                                                        <TableCell align="left" sx={{ borderBottom: 'none' }}>{row?.orderNo}</TableCell>
                                                                        <TableCell align="left" sx={{ borderBottom: 'none' }}>{findOrderCreateTime(row)}</TableCell>
                                                                        <TableCell align="right" sx={{ borderBottom: 'none' }}>
                                                                            <IconButton size="large" color="inherit" onClick={(e: any) => controller.handleOpenMenu(e, row?.id)}>
                                                                                <MoreHorizIcon />
                                                                            </IconButton>
                                                                        </TableCell>
                                                                    </TableRow>
                                                                </Hidden>
                                                            </>
                                                        )
                                                    })
                                                }
                                            </TableBody>
                                        </Table>
                                    </TableContainer>
                                    <Divider sx={{ mt: 1, mb: 1 }} />
                                    {
                                        controller.loadingFetchDataMore
                                        &&
                                        <Box mb={2} mt={2}>
                                            <LinearProgress />
                                        </Box>
                                    }
                                    <Box sx={{ display: 'flex', justifyContent: 'end' }}>
                                        <Pagination color="primary" onChange={controller.handlePageChange} page={controller.currentPage} count={controller.countPagination} />
                                    </Box>
                                </Box>
                                :
                                <LinearProgress sx={{ mt: 2 }} />
                        }
                        <Popover
                            open={Boolean(controller.openMenu)}
                            anchorEl={controller.openMenu}
                            onClose={controller.handleCloseMenu}
                            anchorOrigin={{ vertical: 'top', horizontal: 'left' }}
                            transformOrigin={{ vertical: 'top', horizontal: 'right' }}
                            PaperProps={{
                                sx: {
                                    p: 1,
                                    width: 140,
                                    '& .MuiMenuItem-root': {
                                        px: 1,
                                        typography: 'body2',
                                        borderRadius: 0.75,
                                    },
                                },
                            }}
                        >
                            <MenuItem onClick={controller.handleClickViewData}>
                                <InfoIcon />
                                &nbsp;&nbsp;
                                {t("View detail")}
                            </MenuItem>
                        </Popover>

                    </Box>
                    :


                    <OrderDetail onRefetchData={controller.handleRefetchData} selectedData={controller.selectedData} onClose={controller.handleCloseForm} />


                :
                <Box sx={{ display: 'flex', justifyContent: 'center', alignItems: 'center' }}>
                    <LoadingAnimatedIcon />
                </Box>
        }
    </Box>
}
export default ReturnOrderView;